<template>
  <div>
    <h2 class="mb-6 text-center" id="payment-method-heading">- {{ $t("shop.choose-payment-method") }} -</h2>

    <div
      v-for="(method, index) in paymentItems.methods"
      :key="'method' + index"
      class="w-full bg-gray-200 rounded py-6 px-6 mb-2"
    >
      <div class="flex justify-between">
          <label class="pr-5">
            <input
              type="radio"
              :value="method.uuid"
              v-model="selectedMethod"
            />
            {{ method.name }}
          </label>
          <span>
            <i v-if="'paypal' == method.uuid" class="fab fa-paypal"></i>
            <i v-if="'cod' == method.uuid" class="far fa-money-bill-alt"></i>
            <i v-if="'wire' == method.uuid" class="fas fa-file-invoice-dollar"></i>
            <i v-if="'stripe' == method.uuid" class="fab fa-stripe"></i>
            <!-- <i class="fas fa-credit-card"></i> -->
          </span>  
      </div>
    </div>

    <div
      class="
        mt-6
        sm:flex sm:items-center sm:justify-between
      "
    >
      <button
        @click="save()"
        type="submit"
        class="block sm:flex sm:items-center px-4 py-3 rounded font-bold 
              text-sm cursor-pointer bg-green-500 text-white hover:bg-green-400
              text-center
              w-full sm:w-auto
              sm:order-last
        "
      >
        {{ $t("common.next") }}
      </button>

      <p class="mt-4 text-center text-sm text-gray-500 sm:mt-0 sm:text-left">
        {{ $t("shop.not-charget-yet") }}
      </p>
    </div>
  </div>
</template>


<script>
import axios from "axios";

export default {
  components: {
  },
  props: {
    paymentItems: Object,
  },
  data() {

    return {
      processing: false,
      selectedMethod: this.paymentItems.selected || ( this.paymentItems.methods.length ? this.paymentItems.methods[0].uuid : this.paymentItems.selected)
    };
  },
  methods: {

    async save() {
      let data = {
        paymentMethod: this.selectedMethod
      };
      let url = "/shop/save-payment-methods";

      await axios({
        method: "post",
        url: url,
        data: data,
      }).then(
        (response) => {
          //success
          let currentStep = this.$parent.step;
          this.$emit('step-change', response.data);
          let newStep = this.$parent.step;
          if(newStep !==currentStep){
            this.$toastr.s("", this.$t("common.data-saved"));
            // window.location.reload();//load correct summary, based on shipping cost
          }else{
            this.$toastr.e(this.$t("common.generic-error"), this.$t("common.save-error-title"));
          }
          
        },
        (error) => {
          if (typeof error.response !== "undefined") {
            if (error.response.data) {
              if (error.response.data.errors) {
                // component.errors = error.response.data.errors;
                console.error(error.response.data.errors)
              }

              if (error.response.data.message) {
                console.error(error.response.data.message);
              }
            }
          }
          this.$toastr.e(error.message, this.$t("common.save-error-title"));
        }
      );

      this.processing = false;
    },
  },
};
</script>
